import { cn } from '@/lib/utils';

import PricingSectionCardCell from '@/blocks/PricingSection/Desktop/Components/PricingSectionCardCell';
import Badge from '@/components/atoms/badge';
import { Text } from '@/components/atoms/Text';

import PricingSectionHeaderColumnSecondaryText from './PricingSectionHeaderColumnSecondaryText';
import { PricingSectionCardCellProps } from './PricingSectionPriceCardCell';
const PricingSectionHeaderColumnCardCell = (
  props: PricingSectionCardCellProps
) => {
  return (
    <PricingSectionCardCell
      {...props}
      classNames={{
        wrapper: 'justify-start text-left px-4',
      }}
    >
      {props.isHeaderCell ? (
        <div className='flex flex-col'>
          <Text classNames={{ wrapper: 'font-serif' }} variant='h4'>
            {props.primaryText}
          </Text>
          <Text
            classNames={{
              wrapper: cn('', props.isHeaderColumn && 'text-left'),
            }}
            variant='body-s'
          >
            {props.secondaryText}
          </Text>
        </div>
      ) : (
        <>
          {props.primaryText && (
            <Badge
              classNames={{ root: 'light' }}
              color='gradient'
              variant='soft'
            >
              {props.primaryText}
            </Badge>
          )}
          {props.secondaryText && (
            <PricingSectionHeaderColumnSecondaryText
              text={props.secondaryText}
            />
          )}
        </>
      )}
    </PricingSectionCardCell>
  );
};

export default PricingSectionHeaderColumnCardCell;
